var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEvaluareaServiciilor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.127,
    height: 107.404,
    viewBox: "0 0 151.127 107.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_109",
    x: 17.861,
    y: 0,
    width: 50.427,
    height: 49.283,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_114",
    x: 110.524,
    y: 4.162,
    width: 40.603,
    height: 39.806,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_120",
    x: 61.836,
    y: 60.006,
    width: 58.463,
    height: 39.359,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_129",
    x: 0,
    y: 61.284,
    width: 47.148,
    height: 46.12,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphics-evaluation",
    transform: "translate(-387.225 -589.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M524.131,686.694H419.126a.341.341,0,0,1-.341-.341V620.225a.341.341,0,0,1,.341-.341h104.96a.341.341,0,0,1,.341.341l.045,66.127a.341.341,0,0,1-.341.341Zm-104.664-.682H523.789l-.044-65.445H419.467Z",
    transform: "translate(-7.767 -7.867)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M509.5,737.655H459.281a.341.341,0,0,1,0-.682H509.5a.341.341,0,0,1,0,.682Z",
    transform: "translate(-20.531 -45.086)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M475.784,731.7a.327.327,0,0,1-.085-.011.341.341,0,0,1-.246-.414l3.247-12.772a.341.341,0,0,1,.661.168l-3.247,12.772A.341.341,0,0,1,475.784,731.7Z",
    transform: "translate(-25.776 -39.134)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M513.3,731.7a.34.34,0,0,1-.33-.257l-3.248-12.772a.341.341,0,0,1,.661-.168l3.247,12.772a.34.34,0,0,1-.246.414A.321.321,0,0,1,513.3,731.7Z",
    transform: "translate(-36.671 -39.134)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 95.285,
    height: 57.294,
    transform: "translate(415.782 616.871)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M521.236,684.476H425.269V626.5h95.967Zm-95.285-.682h94.6V627.182h-94.6Z",
    transform: "translate(-9.828 -9.971)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M495.32,624.938a1.213,1.213,0,1,1,1.214-1.213A1.215,1.215,0,0,1,495.32,624.938Zm0-1.744a.531.531,0,1,0,.531.531A.532.532,0,0,0,495.32,623.194Z",
    transform: "translate(-31.709 -8.703)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 387.22, 589.47)",
    filter: "url(#Path_109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109-2",
    "data-name": "Path 109",
    d: "M455.7,595.633H423.282v31.283h32.427Z",
    transform: "translate(-396.42 -589.63)",
    fill: "#006ab3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M455.55,627.1H423.123a.341.341,0,0,1-.341-.341V595.474a.341.341,0,0,1,.341-.341h32.413a.341.341,0,0,1,.341.341l.014,31.283a.34.34,0,0,1-.341.341Zm-32.086-.682h31.745l-.014-30.6H423.464Z",
    transform: "translate(-9.037)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.428,
    cy: 2.428,
    r: 2.428,
    transform: "translate(422.451 603.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M437.814,612.595a2.769,2.769,0,1,1,2.769-2.769A2.772,2.772,0,0,1,437.814,612.595Zm0-4.855a2.087,2.087,0,1,0,2.087,2.087A2.089,2.089,0,0,0,437.814,607.739Z",
    transform: "translate(-12.935 -3.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.428,
    cy: 2.428,
    r: 2.428,
    transform: "translate(433.365 603.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M453.814,612.595a2.769,2.769,0,1,1,2.769-2.769A2.772,2.772,0,0,1,453.814,612.595Zm0-4.855a2.087,2.087,0,1,0,2.087,2.087A2.089,2.089,0,0,0,453.814,607.739Z",
    transform: "translate(-18.021 -3.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M442.639,629.379a9.557,9.557,0,0,1-9.463-8.335.512.512,0,0,1,1.016-.13,8.516,8.516,0,0,0,16.9,0,.512.512,0,0,1,1.015.13A9.558,9.558,0,0,1,442.639,629.379Z",
    transform: "translate(-12.34 -8.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 387.22, 589.47)",
    filter: "url(#Path_114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114-2",
    "data-name": "Path 114",
    d: "M581.718,601.735H559.125V623.54h22.6Z",
    transform: "translate(-439.6 -591.57)",
    fill: "#117dba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M581.569,623.722h-22.6a.341.341,0,0,1-.341-.341V601.576a.341.341,0,0,1,.341-.341H581.56a.342.342,0,0,1,.341.341l.01,21.805a.341.341,0,0,1-.341.341Zm-22.262-.682h21.921l-.01-21.123H559.307Z",
    transform: "translate(-52.217 -1.94)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M572.545,625.341a6.818,6.818,0,0,1-6.75-5.945.512.512,0,0,1,1.016-.129,5.781,5.781,0,0,0,11.469,0,.512.512,0,1,1,1.015.129A6.816,6.816,0,0,1,572.545,625.341Z",
    transform: "translate(-54.495 -7.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M581.972,614.038a.511.511,0,0,1-.3-.1l-3.385-2.476a.512.512,0,0,1,0-.826l3.385-2.476a.512.512,0,0,1,.6.826l-2.82,2.063,2.82,2.063a.511.511,0,0,1-.3.924Z",
    transform: "translate(-58.4 -4.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M568.587,614.037a.511.511,0,0,1-.3-.924l2.82-2.063-2.82-2.063a.512.512,0,1,1,.6-.826l3.384,2.476a.511.511,0,0,1,0,.826l-3.384,2.476A.513.513,0,0,1,568.587,614.037Z",
    transform: "translate(-55.221 -4.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M582.73,626.846a1.776,1.776,0,0,1-1.134-.407l-.854-.7a.511.511,0,0,1-.071-.72l1.628-1.981a.512.512,0,0,1,.72-.07l.854.7a1.794,1.794,0,0,1-1.144,3.178Zm-.943-1.574.459.378a.77.77,0,0,0,.564.169.771.771,0,0,0,.415-1.361l-.459-.376Z",
    transform: "translate(-59.188 -8.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 387.22, 589.47)",
    filter: "url(#Path_120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120-2",
    "data-name": "Path 120",
    d: "M528.194,683.6H487.749v21.359h40.463Z",
    transform: "translate(-416.91 -617.59)",
    fill: "#edab35"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M528.053,705.141H487.59a.341.341,0,0,1-.341-.341V683.442a.341.341,0,0,1,.341-.341h40.445a.341.341,0,0,1,.341.341l.018,21.358a.341.341,0,0,1-.341.341Zm-40.122-.682h39.78l-.016-20.676H487.931Z",
    transform: "translate(-29.529 -27.962)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M500.366,701.468a.336.336,0,0,1-.159-.039l-2.311-1.216-2.311,1.216a.341.341,0,0,1-.495-.36l.441-2.573-1.87-1.822a.342.342,0,0,1,.19-.583l2.583-.375,1.156-2.342a.341.341,0,0,1,.306-.19h0a.341.341,0,0,1,.306.19l1.156,2.342,2.584.375a.342.342,0,0,1,.189.583l-1.87,1.822.441,2.573a.341.341,0,0,1-.336.4Zm-5.733-4.8,1.5,1.465a.341.341,0,0,1,.1.3l-.355,2.069,1.859-.977a.342.342,0,0,1,.316,0l1.859.977-.355-2.069a.341.341,0,0,1,.1-.3l1.5-1.465-2.077-.3a.342.342,0,0,1-.257-.187L497.9,694.3l-.929,1.883a.344.344,0,0,1-.257.187Z",
    transform: "translate(-31.535 -31.167)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M517.856,701.475a.336.336,0,0,1-.158-.039l-2.311-1.216-2.311,1.216a.342.342,0,0,1-.5-.36l.441-2.573-1.87-1.822a.342.342,0,0,1,.19-.583l2.584-.375,1.155-2.342a.356.356,0,0,1,.612,0l1.156,2.342,2.584.375a.341.341,0,0,1,.189.583l-1.87,1.822.441,2.573a.342.342,0,0,1-.336.4Zm-2.469-1.98a.342.342,0,0,1,.158.039l1.858.977-.355-2.069a.341.341,0,0,1,.1-.3l1.5-1.465-2.077-.3a.342.342,0,0,1-.256-.187l-.929-1.883-.929,1.883a.342.342,0,0,1-.257.187l-2.077.3,1.5,1.465a.342.342,0,0,1,.1.3l-.355,2.069,1.858-.977A.345.345,0,0,1,515.387,699.5Z",
    transform: "translate(-37.094 -31.175)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M535.348,701.468a.337.337,0,0,1-.159-.039l-2.311-1.216-2.311,1.216a.341.341,0,0,1-.495-.36l.441-2.573-1.87-1.822a.342.342,0,0,1,.19-.583l2.583-.375,1.156-2.342a.341.341,0,0,1,.306-.19h0a.341.341,0,0,1,.306.19l1.156,2.342,2.584.375a.341.341,0,0,1,.189.583l-1.87,1.822.441,2.573a.34.34,0,0,1-.136.334A.335.335,0,0,1,535.348,701.468Zm-2.47-1.98a.339.339,0,0,1,.158.039l1.858.977-.355-2.069a.343.343,0,0,1,.1-.3l1.5-1.465-2.078-.3a.341.341,0,0,1-.256-.187l-.929-1.883-.929,1.883a.344.344,0,0,1-.257.187l-2.077.3,1.5,1.465a.341.341,0,0,1,.1.3l-.355,2.069,1.859-.977A.34.34,0,0,1,532.878,699.488Z",
    transform: "translate(-42.654 -31.167)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M573.395,656.569h-13.12v12.663H573.4Z",
    transform: "translate(-52.741 -19.528)",
    fill: "#e30016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M573.241,669.414H560.115a.341.341,0,0,1-.341-.341V656.409a.341.341,0,0,1,.341-.341h13.121a.341.341,0,0,1,.341.341l.005,12.664a.342.342,0,0,1-.341.341Zm-12.785-.682H572.9l-.005-11.982H560.456Z",
    transform: "translate(-52.582 -19.369)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M571.369,667.645a.337.337,0,0,1-.239-.1l-6.115-6.038a.341.341,0,1,1,.479-.485l6.115,6.038a.34.34,0,0,1-.239.583Z",
    transform: "translate(-54.216 -20.913)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M565.254,667.645a.34.34,0,0,1-.239-.583l6.115-6.038a.341.341,0,1,1,.479.485l-6.115,6.038A.336.336,0,0,1,565.254,667.645Z",
    transform: "translate(-54.216 -20.913)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 387.22, 589.47)",
    filter: "url(#Path_129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129-2",
    "data-name": "Path 129",
    d: "M426.234,685.474H397.1v28.12h29.148Z",
    transform: "translate(-388.1 -618.19)",
    fill: "#c42647"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M426.087,713.776H396.939a.341.341,0,0,1-.341-.341v-28.12a.341.341,0,0,1,.341-.341h29.136a.341.341,0,0,1,.341.341l.012,28.12a.34.34,0,0,1-.341.341Zm-28.807-.682h28.466l-.012-27.438H397.28Z",
    transform: "translate(-0.714 -28.557)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.183,
    cy: 2.183,
    r: 2.183,
    transform: "translate(403.744 664.069)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M410.145,700.739a2.524,2.524,0,1,1,2.523-2.523A2.526,2.526,0,0,1,410.145,700.739Zm0-4.365a1.841,1.841,0,1,0,1.841,1.842A1.844,1.844,0,0,0,410.145,696.374Z",
    transform: "translate(-4.218 -31.964)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 2.183,
    cy: 2.183,
    r: 2.183,
    transform: "translate(413.555 664.069)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M424.527,700.739a2.524,2.524,0,1,1,2.524-2.523A2.526,2.526,0,0,1,424.527,700.739Zm0-4.365a1.841,1.841,0,1,0,1.842,1.842A1.844,1.844,0,0,0,424.527,696.374Z",
    transform: "translate(-8.79 -31.964)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M422.523,715.837a.511.511,0,0,1-.507-.447,7.6,7.6,0,0,0-15.085,0,.512.512,0,0,1-1.015-.13,8.627,8.627,0,0,1,17.115,0,.511.511,0,0,1-.443.572A.524.524,0,0,1,422.523,715.837Z",
    transform: "translate(-3.675 -35.789)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M407.971,617.718h-13.12v12.663h13.126Z",
    transform: "translate(-0.159 -7.179)",
    fill: "#00b298"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M407.818,630.564H394.692a.34.34,0,0,1-.341-.341V617.56a.34.34,0,0,1,.341-.341h13.12a.341.341,0,0,1,.341.341l.005,12.662a.34.34,0,0,1-.341.341Zm-12.785-.682h12.443l-.005-11.98H395.033Z",
    transform: "translate(0 -7.02)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M402.092,628.095a.337.337,0,0,1-.239-.1l-2.454-2.422a.341.341,0,1,1,.479-.485l2.213,2.184,4.491-4.475a.341.341,0,0,1,.482.484L402.332,628A.34.34,0,0,1,402.092,628.095Z",
    transform: "translate(-1.572 -8.762)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M516.651,599.306H492.526v14.378h24.135Z",
    transform: "translate(-31.206 -1.326)",
    fill: "#ef3357"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M516.5,613.866H492.367a.341.341,0,0,1-.341-.341V599.147a.341.341,0,0,1,.341-.341h24.124a.341.341,0,0,1,.341.34l.01,14.379a.341.341,0,0,1-.341.341Zm-23.794-.682h23.452l-.01-13.7H492.708Z",
    transform: "translate(-31.048 -1.168)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 1.807,
    cy: 1.807,
    r: 1.807,
    transform: "translate(467.545 604.033)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M503.3,611.977a2.148,2.148,0,1,1,2.149-2.149A2.151,2.151,0,0,1,503.3,611.977Zm0-3.614a1.466,1.466,0,1,0,1.467,1.465A1.467,1.467,0,0,0,503.3,608.363Z",
    transform: "translate(-33.949 -3.989)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.807,
    cy: 1.807,
    r: 1.807,
    transform: "translate(475.669 604.033)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M515.21,611.977a2.148,2.148,0,1,1,2.148-2.149A2.151,2.151,0,0,1,515.21,611.977Zm0-3.614a1.466,1.466,0,1,0,1.466,1.465A1.467,1.467,0,0,0,515.21,608.363Z",
    transform: "translate(-37.734 -3.989)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y1: 2.168,
    x2: 2.604,
    transform: "translate(474.872 601.865)",
    fill: "#27aae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M512.235,607.353a.341.341,0,0,1-.219-.6l2.6-2.169a.341.341,0,0,1,.437.524l-2.6,2.168A.336.336,0,0,1,512.235,607.353Z",
    transform: "translate(-37.363 -2.978)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 2.604,
    y1: 2.168,
    transform: "translate(469.415 601.865)",
    fill: "#27aae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M506.838,607.353a.336.336,0,0,1-.218-.08l-2.6-2.168a.341.341,0,0,1,.437-.524l2.6,2.169a.341.341,0,0,1-.219.6Z",
    transform: "translate(-34.82 -2.978)",
    fill: "#333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvaluareaServiciilor);
export default __webpack_public_path__ + "static/media/icon-evaluarea-serviciilor.f69e2cdccb7a3b9d84c043808be825c8.svg";
export { ForwardRef as ReactComponent };